import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ModalBaseLg = ({ isOpen, onClose, title, childComponent, children, fullscreen = false, container, className = '', size = 'lg' }) => {
    const backdropStyle = 'static';
    const modalStyle = {};
    const [isResponsiveViewport, setIsResponsiveViewport] = useState(
        () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const syncViewport = () => setIsResponsiveViewport(mediaQuery.matches);
        syncViewport();
        mediaQuery.addEventListener('change', syncViewport);
        return () => mediaQuery.removeEventListener('change', syncViewport);
    }, []);

    const shouldUseFullscreen = fullscreen || isResponsiveViewport;
    return (
        <Modal

            isOpen={isOpen}
            backdrop={backdropStyle}
            keyboard={false}
            size={shouldUseFullscreen ? undefined : size}
            zIndex={9999}
            style={modalStyle}
            centered={!shouldUseFullscreen}
            fullscreen={shouldUseFullscreen}
            container={container}
            className={className}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                {childComponent ?? children}
            </ModalBody>
        </Modal >
    )
}

export default ModalBaseLg
